import React from 'react';
import { FiX } from 'react-icons/fi';
import styles from './BulkActionBar.module.css';

const BulkActionBar = ({ selectedCount, onClear, children }) => {
  if (!selectedCount) return null;
  return (
    <div className={styles.bar}>
      <div className={styles.left}>
        <button type="button" className={styles.clear} onClick={onClear} aria-label="Clear selection">
          <FiX />
        </button>
        <span>
          <strong>{selectedCount}</strong> selected
        </span>
      </div>
      <div className={styles.actions}>{children}</div>
    </div>
  );
};

export default BulkActionBar;
